import { UPDATE_WORKSPACE_APPLICATION_CONNECTIONS } from './index';

export const updateWorkspaceApplicationConnectionsAction = (workspace_application_connections) => ({
    type: UPDATE_WORKSPACE_APPLICATION_CONNECTIONS,
    workspace_application_connections
});